import React, { useState, useEffect } from "react";
import styles from "./FaqEngenDynamic.module.scss";
import { Layout, NavigationBanner, Tabs } from "../../../components";
import { getFaqBySlug } from "../../../api/faq.api";
import b2bRoutes from "../../../helpers/b2b.routes";
import useFetchB2B from "../../../helpers/useFetchB2B";

const FaqEngenDynamic = ({ match }) => {
  const { currentPage, pages } = useFetchB2B({
    url: b2bRoutes.FAQ,
  });

  const [faq, setFaq] = useState(null);
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await getFaqBySlug(match.url.split("/")[2]);

        if (response.message === "success") {
          setFaq(response.data.faq);
          setActiveTab("benefits");
        } else {
          console.error(response.message);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [match.url]);

  const handleChangeActiveTab = value => {
    setActiveTab(value);
  };

  const tabs = faq && [
    {
      id: "benefits",
      value: "benefits",
      label: "Benefits",
    },
    {
      id: "suitability",
      value: "suitability",
      label: "Suitability",
    },
    {
      id: "technical",
      value: "technical",
      label: "Technical",
    },
    {
      id: "quality_and_performance",
      value: "quality_and_performance",
      label: "Quality And Performance",
    },
  ];

  return (
    <Layout pageTitle={`${currentPage ? currentPage.title : ""}`} backButton={true}>
      {currentPage && <NavigationBanner pages={pages} activePage={currentPage} />}
      {activeTab && (
        <section className={styles.tabs}>
          <div className={styles.tabsWrapper}>
            <Tabs tabs={tabs} activeTab={activeTab} action={handleChangeActiveTab} />
            <div
              className={styles.tabContent}
              dangerouslySetInnerHTML={{ __html: faq[activeTab] }}
            />
          </div>
        </section>
      )}
    </Layout>
  );
};

export default FaqEngenDynamic;
